import { Component, OnInit } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { faLongArrowRight, faExclamationCircle } from '@fortawesome/pro-regular-svg-icons';

@Component({
  selector: 'app-reset',
  templateUrl: './reset.component.html',
  styleUrls: ['./reset.component.scss']
})
export class ResetComponent {

  mail: string;
  validMail: boolean = null;
  error: string;

  constructor(public auth: AuthService) {}

  resetPass(e) {
    e.preventDefault();
    if(this.validMail) {
      this.auth.reset(this.mail)
    }
  }

  validateMail() {
    if(this.mail != null) {
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.mail)) {
        this.error = null;
        return this.validMail = true;
      } else {
        this.error = 'Bitte geben Sie eine valide E-Mail Adresse ein.';
        return this.validMail = false;
      }
    } else {
      this.error = 'Bitte geben Sie eine E-Mail Adresse ein.'
      return this.validMail = false;
    }
  }

  longArrowRight = faLongArrowRight;
  exclamationCircle = faExclamationCircle;

}
